import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MENU_ITEMS, MenuItem } from '../models/menu-items.model';
import { Role } from '../models/user.model';
import { SessionService } from './session';

@Injectable()
export class MenuService {
  private menuToggleSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  menuToggle$: Observable<boolean> = this.menuToggleSource.asObservable();

  toggleMenu() {
    this.menuToggleSource.next(!this.menuToggleSource.value);
  }

  private merge = (a: MenuItem[], b: MenuItem[]) => {
    const predicate = (a: MenuItem, b: MenuItem) => a.name === b.name;
    const c = [...a];
    b.map(bItem => (c.some(cItem => predicate(bItem, cItem)) ? null : c.push(bItem)));
    return c;
  };

  get menuItems$(): Observable<MenuItem[]> {
    return this.session.getUserData().pipe(
      map(user => {
        if (user) {
          const roles = [...user.roles].sort((a, b) => a.localeCompare(b));
          let menuItems = [] as MenuItem[];
          roles.map(role => {
            const name = `${role.valueOf()}` as keyof typeof Role;
            if (MENU_ITEMS[name]) {
              menuItems = this.merge(menuItems, MENU_ITEMS[name]);
            }
          });
          return menuItems;
        } else {
          return [] as MenuItem[];
        }
      }),
    );
  }

  constructor(private session: SessionService) {}
}
